<template>
  <div>
    <div class="row">
      <div class="col-xl-12">
        <div class="card card-custom gutter-b card-stretch">
          <div class="card-header border-0 pt-5">
            <h3 class="card-title align-items-start flex-column">
              <span class="card-label font-weight-bolder text-dark"
                >Configuração de Valor Faixa no Ranking</span
              >
              <span class="text-muted mt-3 font-weight-bold font-size-sm"
                >Valores utilizados para revendas / renovações</span
              >
            </h3>
            <div class="card-toolbar">
              <ul class="nav nav-pills nav-pills-sm nav-dark-75">
                <li
                  class="nav-item"
                  v-for="(faixa, index) in revendas.faixa"
                  :key="'faixa' + index"
                >
                  <a
                    :class="
                      id_faixa_revenda == faixa['ID_FAIXA']
                        ? 'nav-link py-2 px-4 active'
                        : 'nav-link py-2 px-4'
                    "
                    data-toggle="tab"
                    href="javascript:void(0)"
                    @click="() => (id_faixa_revenda = faixa['ID_FAIXA'])"
                    >{{ faixa["DESCRICAO"] }}</a
                  >
                </li>
                <li class="nav-item">
                  <a
                    :class="
                      id_faixa_revenda == null
                        ? 'nav-link py-2 px-4 active'
                        : 'nav-link py-2 px-4'
                    "
                    data-toggle="tab"
                    @click="() => (id_faixa_revenda = null)"
                    href="javascript:void(0)"
                    >Todos</a
                  >
                </li>
              </ul>
            </div>
          </div>
          <div class="card-body pt-5 pb-0 mt-n3">
            <div class="table-">
              <table class="table table-borderless table-vertical-center">
                <thead>
                  <tr>
                    <th class="p-0 min-w-150px">Kit</th>
                    <th class="p-0">Faixa. Rev.</th>
                    <th class="p-0">SaaS</th>
                    <th class="p-0">Produto</th>
                    <th class="p-0">Valor</th>
                    <th class="p-0">Qtd. De</th>
                    <th class="p-0">Qtd. Até</th>
                    <th class="p-0 min-w-110px">Alterado Por</th>
                    <th class="p-0 min-w-50px"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(valor, index) in valroes" :key="'valor' + index">
                    <template
                      v-if="
                        valor.id_faixa_revenda == id_faixa_revenda ||
                          id_faixa_revenda == null
                      "
                    >
                      <td class="pl-0">
                        <a
                          href="#"
                          class="text-dark font-weight-bolder text-hover-primary mb-1 font-size-lg"
                          >ID KIT: {{ valor.id_kit }}</a
                        >
                        <span class="text-muted font-weight-bold d-block">{{
                          valor.collection_kit
                            ? valor.collection_kit["DESCRICAO"]
                            : ""
                        }}</span>
                      </td>
                      <td class="pl-0">
                        <span class="text-muted font-weight-500"
                          >{{
                            valor.collection_faixa
                              ? valor.collection_faixa["DESCRICAO"]
                              : ""
                          }}
                        </span>
                      </td>
                      <td class="pl-0">
                        <span class="text-muted font-weight-500"
                          >{{ valor.collection_kit["SAAS"] }}
                        </span>
                      </td>
                      <td class="pl-0">
                        <span class="text-muted font-weight-500"
                          >{{ valor.collection_kit["PRODUTO"] }}
                        </span>
                      </td>
                      <td class="pl-0">
                        <span class="text-muted font-weight-500"
                          >R$
                          {{ numberToReal(valor.collection_kit["VLR_BASE"]) }}
                        </span>
                      </td>
                      <td class="pl-0">
                        <span class="text-muted font-weight-500"
                          >{{ valor.qtd_de }}
                        </span>
                      </td>
                      <td class="pl-0">
                        <span class="text-muted font-weight-500"
                          >{{ valor.qtd_ate }}
                        </span>
                      </td>
                      <td class="pl-0">
                        <a
                          href="#"
                          class="text-dark font-weight-bolder text-hover-primary mb-1 font-size-lg"
                          >{{
                            valor.collection_usuario
                              ? valor.collection_usuario["NOME"]
                              : ""
                          }}</a
                        >
                        <span class="text-muted font-weight-bold d-block">{{
                          formatDate(valor.updated_at, "DD/MM/YYYY HH:mm:ss")
                        }}</span>
                      </td>
                      <td class="text-right pr-0">
                        <router-link
                          class="btn btn-icon btn-light btn-sm mr-5"
                          title="Editar"
                          :to="{
                            name:
                              'configuracoesRenonvacaoRankingRevendasUpdate',
                            params: {
                              id: valor.id
                            }
                          }"
                        >
                          <span class="svg-icon svg-icon-md svg-icon-primary">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              version="1.1"
                            >
                              <g
                                stroke="none"
                                stroke-width="1"
                                fill="none"
                                fill-rule="evenodd"
                              >
                                <polygon points="0 0 24 0 24 24 0 24"></polygon>
                                <rect
                                  fill="#000000"
                                  opacity="0.3"
                                  transform="translate(12.000000, 12.000000) rotate(-90.000000) translate(-12.000000, -12.000000)"
                                  x="11"
                                  y="5"
                                  width="2"
                                  height="14"
                                  rx="1"
                                ></rect>
                                <path
                                  d="M9.70710318,15.7071045 C9.31657888,16.0976288 8.68341391,16.0976288 8.29288961,15.7071045 C7.90236532,15.3165802 7.90236532,14.6834152 8.29288961,14.2928909 L14.2928896,8.29289093 C14.6714686,7.914312 15.281055,7.90106637 15.675721,8.26284357 L21.675721,13.7628436 C22.08284,14.136036 22.1103429,14.7686034 21.7371505,15.1757223 C21.3639581,15.5828413 20.7313908,15.6103443 20.3242718,15.2371519 L15.0300721,10.3841355 L9.70710318,15.7071045 Z"
                                  fill="#000000"
                                  fill-rule="nonzero"
                                  transform="translate(14.999999, 11.999997) scale(1, -1) rotate(90.000000) translate(-14.999999, -11.999997)"
                                ></path>
                              </g>
                            </svg>
                          </span>
                        </router-link>
                        <button
                          @click="excluir(valor)"
                          class="btn btn-light-danger btn-sm btn-bold"
                        >
                          <Close :size="16" />
                        </button>
                      </td>
                    </template>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ApplicationMixin from "@/modules/Application/mixins/SistemaMixin";
import Close from "vue-material-design-icons/Close.vue";

export default {
  name: "app-config-renovacoes-valor-ranking-faixa",
  mixins: [ApplicationMixin],
  components: {
    Close
  },
  data() {
    return {
      revendas: {},
      valroes: [],
      id_faixa_revenda: null
    };
  },
  methods: {
    async getRevendas() {
      try {
        const { data } = await this.$http.post("/renovacoes/revendas");
        this.revendas = data;
      } catch {
        return [];
      }
    },
    async getValores() {
      try {
        const { data } = await this.$http.get(
          "/renovacoes/config/valor/ranking-faixa"
        );
        this.valroes = data;
      } catch {
        return [];
      }
    },
    excluir(data) {
      this.$swal
        .fire({
          icon: "info",
          title: "Excluir o ID KIT " + data.id_kit + "?",
          showCancelButton: true,
          confirmButtonText: `Sim`,
          cancelButtonText: `Não`
        })
        .then(async result => {
          if (result.isConfirmed) {
            await this.$http.post(
              "/renovacoes/config/valor/ranking-faixa/delete",
              {
                id: data.id
              }
            );
            this.getValores();
            this.$toast.success("Registro excluído!");
          }
        });
    }
  },
  computed: {
    ...mapGetters(["layoutConfig"]),
    config() {
      return this.layoutConfig();
    }
  },
  mounted() {
    this.getRevendas();
    this.getValores();
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "Configurações de Renovação",
        action: {
          title: "Nova",
          url: "configuracoesRenonvacaoRankingRevendasCreate"
        }
      }
    ]);
  }
};
</script>
